<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <ShipperSettingEditForm
          :account-id="$route.params.accountId"
          :team-id="$route.params.teamId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import ShipperSettingEditForm from '@/components/Application/Manage/Account/TeamShipperSettingEditForm'

export default {
  components: {
    ShipperSettingEditForm
  },
  data () {
    return {
      breadcrumb: {
        name: 'Application Settings',
        route: { name: 'manage-accounts-account-configurations-teams-team-shippersettings', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } }
      }
    }
  }
}
</script>

<style>

</style>
